<template>
    <div>
        <div class="x-container" @click="$emit('closeModal');">
            <img class="x-img" src="@/assets/x.svg" />
        </div>
        <div class="editModalTitle">
            <h1>{{user.first_name}} {{user.last_name}}</h1>
        </div>
        <hr>
        <b-alert :show="showErrorAlert" dismissible @dismissed="showErrorAlert=false;" variant="danger">Scegliere almeno un ruolo per questo utente.</b-alert>
        <b-form-group  label="Imposta il/i ruolo/i per l'utente selezionato">
            <b-form-checkbox
            v-for="option in editUserOptions"
            :key="option.value"
            :value="option.value"
            v-model="selectedUserRoles"
            class="checkbox-item"
            >
            <span class="title">{{ option.title }} </span>
            <br />
            <span class="subtitle">{{option.subtitle}}</span>
            </b-form-checkbox>
        </b-form-group>
    </div>      
</template>

<script>
import { mixins } from "@/mixins";

export default {
    name: 'EditUserGroup',
    props:{
        user: Object,
    },
    mixins: [mixins],
    data() {
        return {
            selectedUserRoles: [],
            editUserOptions: [
                {value: 'dottori', title: 'Dottore', subtitle: 'Può accedere alle bolle e alle certificazioni relative ai propri pazienti. '},
                {value: 'gestori', title: 'Gestore', subtitle: 'Può accedere ad ogni bolla e certificazione rilasciata verso lo studio. N.B. questo utente non apparirà come dottore e non potrà avere pratiche aperte a suo nome. Se l’utente è un dottore, selezionare anche la casella qui sopra.'},
                {value: 'admin', title: 'Admin', subtitle: 'Stessi privilegi dell’utente gestionale e, in più, può verificare altri utenti, cambiarne i ruoli e visualizzare e modificare informazioni relative ai laboratori.'},
            ],
            showErrorAlert: false
        }
    },
    mounted(){
        this.selectedUserRoles = [];
        this.$axios
        .get(this.$apibase + '/api/users/get_user_group/', {
            headers: {
                Authorization:"JWT " + localStorage.getItem('access_token')
            },
            params: {
                user: this.user.uid
            }
        })
        .then(response => {
            for(var group of response.data){
                this.selectedUserRoles.push(group);
            }
        })
        .catch((e)=> {
            if (e.response.status == 403)
                this.logout();
            else
                alert(e);
        })
    }
}
</script>

<style scoped>
    .x-container{
        text-align: right;
        margin-bottom: 20px;
        padding-right: 30px;
        cursor: pointer;
    }
    .x-img{
        width: 15px;
    }
    .title{
        color: black;
    }
    .checkbox-item{
        padding-top: 20px;
        padding-bottom: 20px;
    }
    .editModalTitle{
        text-align: center;
        padding: 20px 0 40px;
    }
    span,h1 {
        color: #707070;
    }
</style>